import axios from 'axios'
import { useErrorHandling } from '@/composables'
import { ENDPOINTS } from '@/endpoints'
import type { GenericAbortSignal } from 'axios'
import type { APIResponse, BranchSearchResult, PaginatedData } from '@/types'

export const searchLocation = async (
    keyword: string,
    contentKey: string,
    pageNumber = 1,
    pageSize = 12,
    signal?: GenericAbortSignal
): Promise<PaginatedData<BranchSearchResult>> => {
    if (!contentKey) return { items: [], count: 0, totalPages: 0, currentPageNumber: 1, pageSize }

    const request = axios.get<APIResponse<PaginatedData<BranchSearchResult>>>(
        `${ENDPOINTS.PANEL_LOCATOR}`,
        {
            params: {
                keyword,
                contentKey,
                pageNumber,
                pageSize
            },
            signal,
        }
    )

    const response = await useErrorHandling(request)

    return response.data.data
}
